export default __webpack_public_path__ + "static/media/Gregory Meeks.a080c82b.jpg";